import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import { reactive } from 'vue';
import { message, notification } from 'ant-design-vue';
import { agree_request_order, refuse_request_order, get_product } from '@/api/jms-model.ts';
import modalBox from '@/components/form-modal/modal-tools';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';

export const event_obj = mitt();
export const btn_list = [
  {
    name: '通过',
    clazz: 'primary',
    is_show: (record: any) => {
      return record.status == 0;
    },
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      get_product({ org_id: current_org.id, product_id: data.product_id, is_active: true }).then(
        (res: any) => {
          const editModal = reactive({
            visible: true,
            loading: false,
            title: '报单审批（通过）',
            form: {
              settings: {
                labelAlign: 'right',
                layout: 'horizontal',
                col: [4, 4],
              },
              fields: [
                {
                  type: 'input',
                  name: 'product__name',
                  label: '产品名称',
                  disabled: true,
                  allowClear: true,
                  inputType: 'text',
                  defaultValue: '',
                },
                {
                  type: 'input',
                  name: 'num',
                  label: '产品数量',
                  disabled: true,
                  allowClear: true,
                  inputType: 'number',
                  defaultValue: '',
                },
                {
                  type: 'input',
                  name: 'price',
                  label: '产品单价',
                  disabled: true,
                  allowClear: true,
                  inputType: 'number',
                  defaultValue: '',
                },
                {
                  type: 'input',
                  name: 'total_price',
                  label: '产品金额',
                  disabled: true,
                  allowClear: true,
                  inputType: 'number',
                  defaultValue: '',
                },
                {
                  type: 'input',
                  name: 'czje',
                  label: '充值使用金额',
                  disabled: false,
                  allowClear: true,
                  inputType: 'number',
                  defaultValue: '',
                  placeholder: '请填写充值使用金额',
                },
                {
                  type: 'input',
                  name: 'flje',
                  label: '返利使用金额',
                  disabled: false,
                  allowClear: true,
                  inputType: 'number',
                  defaultValue: '',
                  placeholder: '请填写返利使用金额',
                },
                {
                  type: 'input',
                  name: 'zjfl',
                  label: '直接返利',
                  disabled: false,
                  allowClear: true,
                  inputType: 'number',
                  defaultValue: '',
                  placeholder: '请填写直接返利',
                },
                `       {
                  type: 'textarea',
                  name: 'mark',
                  label: '备注（通过）',
                  disabled: false,
                  allowClear: true,
                  inputType: 'text',
                  maxlength: 300,
                  defaultValue: '',
                  placeholder: '请填写备注',
                },`,
              ],
              rules: {},
              model: reactive({
                org_id: current_org?.id,
                is_active: true,
                mark: null,
                czje: null,
                flje: null,
                zjfl: null,
                product__name: res.name,
                num: data.num,
                price: res.price,
                total_price: Number(data.num * res.price),
                requestorder_id: Number(data.id),
              }),
            },
            options: {},
            ok: (payload: any) => {
              if (
                Number(payload.czje) + Number(payload.flje) + Number(payload.zjfl) !=
                Number(payload.total_price)
              ) {
                notification.error({
                  message: '金额输入错误',
                  description: '下单金额应等于【充值使用金额】+【下单返利金额】+【直接返利金额】',
                });
                return false;
              }
              return new Promise(resolve => {
                editModal.loading = true;
                agree_request_order(payload)
                  .then(() => {
                    message.success('通过成功');
                    event_obj.emit('refresh');
                    resolve(null);
                  })
                  .finally(() => {
                    editModal.loading = false;
                  });
              });
            },
          });
          modalBox(editModal);
        },
      );
    },
  },
  {
    name: '拒绝',
    clazz: 'danger',
    is_show: (record: any) => {
      return record.status == 0;
    },
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '报单审批（拒绝）',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
          },
          fields: [
            {
              type: 'textarea',
              name: 'mark',
              label: '备注（拒绝）',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              maxlength: 300,
              defaultValue: '',
              placeholder: '请填写备注',
            },
          ],
          rules: {},
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            mark: null,
            requestorder_id: Number(data.id),
          }),
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            refuse_request_order(payload)
              .then(() => {
                message.success('拒绝成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
